import * as yup from 'yup';

const locale = {
  // eslint-disable-next-line no-template-curly-in-string
  color: '${path} must be a valid color',
  // eslint-disable-next-line no-template-curly-in-string
  emailList: '${path} must be a valid list of emails separated by new line',

  string: 'Only alpha characters or spaces',
};

// eslint-disable-next-line
const rEmail = /^(((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))(\r?\n)*)+$/i;

yup.addMethod<yup.StringSchema>(yup.string, 'color',
  function color(message = locale.color) {
    const { style } = new Option();

    return this.test({
      name: 'color',
      message,
      test: (value) => {
        if (!value) {
          return true;
        }

        style.color = value;
        return style.color !== '';
      },
    });
  });

// eslint-disable-next-line
const internationalRegExp = /^[\p{Alpha}\p{M}\p{Pc}\p{Join_C}\s?]+$/u;
yup.addMethod<yup.StringSchema>(yup.string, 'international',
  function international(message = locale.string) {
    return this.matches(internationalRegExp, {
      message,
    });
  });

yup.addMethod<yup.StringSchema>(yup.string, 'emailList',
  function emailList(message = locale.emailList) {
    return this.matches(rEmail, {
      message,
      excludeEmptyString: true,
    });
  });

function hydrateShapeObjects<U extends object>(
  schema: yup.ObjectSchemaDefinition<U>,
): yup.ObjectSchemaDefinition<U> {
  return Object.entries(schema)
    .reduce((newSchema, [key, currentSchema]: any) => ({
      ...newSchema,
      [key]: currentSchema.constructor === Object
        ? yup.object().shape(hydrateShapeObjects(currentSchema))
        : currentSchema,
    }) as yup.ObjectSchemaDefinition<U>, {} as yup.ObjectSchemaDefinition<U>);
}

function unpackDotSchema<U extends object>(
  schema: Record<string, yup.Schema<U[keyof U]>>,
) {
  return Object.entries(schema).reduce((newSchema, [path, currentSchema]) => {
    const pathParts = path.split('.');
    let pathIndex = 0;
    let target = newSchema;

    while (pathIndex < pathParts.length - 1) {
      // @ts-ignore
      const newTarget = target[pathParts[pathIndex]];
      // @ts-ignore
      target = target[pathParts[pathIndex]] = newTarget === undefined ? {} : newTarget;
      pathIndex++;
    }

    // @ts-ignore
    target[pathParts[pathIndex]] = currentSchema;

    return newSchema;
  }, {} as yup.ObjectSchemaDefinition<U>);
}

yup.addMethod<yup.ObjectSchema>(yup.object, 'dotShape',
  function dotShape<U extends object>(
    this: yup.ObjectSchema,
    schema: Record<string, yup.Schema<U[keyof U]>>,
    excludes: Array<[string, string]> = [],
  ) {
    return this.shape(
      hydrateShapeObjects(
        unpackDotSchema(
          schema,
        ),
      ),
      excludes,
    );
  });

export default yup;
